import { ReactElement, useCallback, useEffect } from 'react';
import { App } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useStore } from 'zustand';

import { toastStore } from 'shared/model/toast';
import { mapToast } from './lib/mapToast';

// TODO: move to hook
export const ToastProvider = (): ReactElement => {
  const { t } = useTranslation();
  const { notification: antdToast } = App.useApp();

  const location = useLocation();

  const { toasts, closeToasts } = useStore(toastStore);

  const onLocationChange = useCallback(() => {
    Object.keys(toasts.short).forEach((key) => {
      antdToast.destroy(key);
    });
    Object.keys(toasts.long).forEach((key) => {
      antdToast.destroy(key);
    });
    closeToasts('short');
    closeToasts('long');
  }, [antdToast, closeToasts, toasts.long, toasts.short]);

  useEffect(() => {
    if (Object.keys(toasts.short).length || Object.keys(toasts.long).length) {
      onLocationChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    Object.keys(toasts).forEach((type) => {
      const castedKey = type as keyof typeof toasts;
      const toastsList = toasts[castedKey];

      Object.keys(toastsList).forEach((key) => {
        const { method, ...toast } = toastsList[key];
        const toastConfig = mapToast(antdToast, toast, t);
        antdToast[method](toastConfig);
      });
    });
  }, [antdToast, toasts, t]);

  return <div />;
};
